var _polygon, _polygon2, _polygon3, _polygon4, _polygon5, _polygon6, _polygon7, _polygon8;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSygnet(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Warstwa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "173.2px",
    height: "200px",
    viewBox: "0 0 173.2 200",
    enableBackground: "new 0 0 173.2 200",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    fill: "#61DAFB",
    points: "0,150 0,50 86.6,0 173.2,50 173.2,150 86.6,200 "
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#FFFFFF",
    points: "86.6,133.3 57.7,116.7 57.7,83.3 86.6,66.7 115.5,83.3 144.3,66.7 86.6,33.3 28.9,66.7 28.9,133.3  86.6,166.7 144.3,133.3 115.5,116.7 "
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    opacity: 0.04,
    stroke: "#FFFFFF",
    strokeMiterlimit: 10,
    enableBackground: "new    ",
    points: "0,50 86.6,100 86.6,0 "
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    opacity: 0.04,
    stroke: "#FFFFFF",
    strokeMiterlimit: 10,
    enableBackground: "new    ",
    points: "0,150 86.6,200 86.6,100 "
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    opacity: 0.08,
    stroke: "#FFFFFF",
    strokeMiterlimit: 10,
    enableBackground: "new    ",
    points: "86.6,100 173.2,150 173.2,50  "
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    fillOpacity: 0,
    points: "86.6,100 0,50 0,150 "
  })), _polygon7 || (_polygon7 = /*#__PURE__*/React.createElement("polygon", {
    opacity: 0.08,
    stroke: "#FFFFFF",
    strokeMiterlimit: 10,
    enableBackground: "new    ",
    points: "173.2,150 86.6,100 86.6,200  "
  })), _polygon8 || (_polygon8 = /*#__PURE__*/React.createElement("polygon", {
    opacity: 0.08,
    stroke: "#FFFFFF",
    strokeMiterlimit: 10,
    enableBackground: "new    ",
    points: "173.2,50 86.6,0 86.6,100 "
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSygnet);
export default __webpack_public_path__ + "static/media/sygnet.bd2efe419cd1449128177a00c9b78063.svg";
export { ForwardRef as ReactComponent };